import {type Runtime} from "@common-core/web-component-runtime/runtime";

export const runtimes: Runtime[] = [
  {
    id: "live/prod",
    deployment: "live",
    partition: "prod"
  },
  {
    id: "live/non-prod",
    deployment: "live",
    partition: "non-prod"
  },
  {
    id: "dz/prod",
    deployment: "dz",
    partition: "prod"
  },
  {
    id: "dz/non-prod",
    deployment: "dz",
    partition: "non-prod"
  }
];
